<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__header__start -->

<!-- #endregion customCode: page-component-html__header__start -->

<!-- Container: Main Container -->
<div class="rappider-container main-container col-12">
  <!-- Container: Container 2 -->
  <div class="rappider-container container-2 col-12 p-0 m-0 position-relative">
    <!-- Container: Container 3 -->
    <div
      class="rappider-container container-3 col-12 p-0 m-0 position-relative"
    >
      <!-- Container: Container 4 -->
      <div class="rappider-container container-4 col-12 p-0 m-0">
        <div class="rappider-component">
          <!-- Component: Image 1 -->
          <rappider-image
            [source]="image_1.source"
            [alternateText]="image_1.alternateText"
            [placeholder]="image_1.placeholder"
            [disablePreview]="image_1.disablePreview"
            [borderSettings]="image_1.borderSettings"
            [shadowSettings]="image_1.shadowSettings"
            [paddingSettings]="image_1.paddingSettings"
            [marginSettings]="image_1.marginSettings"
            [customSizeSettings]="image_1.customSizeSettings"
          >
          </rappider-image>
        </div>

        <!-- Container: Container 5 -->
        <div class="rappider-container container-5 col-7 py-0">
          <div class="rappider-component">
            <!-- Component: Button 2 -->
            <rappider-button
              [text]="button_2.text"
              [type]="button_2.type"
              [shape]="button_2.shape"
              [size]="button_2.size"
              [colorType]="button_2.colorType"
              [icon]="button_2.icon"
              [iconPlacement]="button_2.iconPlacement"
              [transparent]="button_2.transparent"
              [loading]="button_2.loading"
              [block]="button_2.block"
              [disabled]="button_2.disabled"
              [key]="button_2.key"
              [emitWithoutPopconfirm]="button_2.emitWithoutPopconfirm"
              [popconfirmTitle]="button_2.popconfirmTitle"
              [borderSettings]="button_2.borderSettings"
              [marginSettings]="button_2.marginSettings"
              [paddingSettings]="button_2.paddingSettings"
              [shadowSettings]="button_2.shadowSettings"
              [customColorSettings]="button_2.customColorSettings"
              [customSizeSettings]="button_2.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 3 -->
            <rappider-button
              [text]="button_3.text"
              [type]="button_3.type"
              [shape]="button_3.shape"
              [size]="button_3.size"
              [colorType]="button_3.colorType"
              [icon]="button_3.icon"
              [iconPlacement]="button_3.iconPlacement"
              [transparent]="button_3.transparent"
              [loading]="button_3.loading"
              [block]="button_3.block"
              [disabled]="button_3.disabled"
              [key]="button_3.key"
              [emitWithoutPopconfirm]="button_3.emitWithoutPopconfirm"
              [popconfirmTitle]="button_3.popconfirmTitle"
              [borderSettings]="button_3.borderSettings"
              [marginSettings]="button_3.marginSettings"
              [paddingSettings]="button_3.paddingSettings"
              [shadowSettings]="button_3.shadowSettings"
              [customColorSettings]="button_3.customColorSettings"
              [customSizeSettings]="button_3.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 4 -->
            <rappider-button
              [text]="button_4.text"
              [type]="button_4.type"
              [shape]="button_4.shape"
              [size]="button_4.size"
              [colorType]="button_4.colorType"
              [icon]="button_4.icon"
              [iconPlacement]="button_4.iconPlacement"
              [transparent]="button_4.transparent"
              [loading]="button_4.loading"
              [block]="button_4.block"
              [disabled]="button_4.disabled"
              [key]="button_4.key"
              [emitWithoutPopconfirm]="button_4.emitWithoutPopconfirm"
              [popconfirmTitle]="button_4.popconfirmTitle"
              [borderSettings]="button_4.borderSettings"
              [marginSettings]="button_4.marginSettings"
              [paddingSettings]="button_4.paddingSettings"
              [shadowSettings]="button_4.shadowSettings"
              [customColorSettings]="button_4.customColorSettings"
              [customSizeSettings]="button_4.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Dropdown Menu 5 -->
            <rappider-dropdown-menu
              [icon]="dropdownMenu_5.icon"
              [placement]="dropdownMenu_5.placement"
              [triggerType]="dropdownMenu_5.triggerType"
              [items]="dropdownMenu_5.items"
              [label]="dropdownMenu_5.label"
              [labelMode]="dropdownMenu_5.labelMode"
            >
            </rappider-dropdown-menu>
          </div>

          <div class="rappider-component">
            <!-- Component: Cart Preview  6 -->
            <rappider-cart-preview
              [cartItem]="cartPreview_6.cartItem"
              [footer]="cartPreview_6.footer"
              [footerContent]="cartPreview_6.footerContent"
              [buttons]="cartPreview_6.buttons"
              [dropdownButton]="cartPreview_6.dropdownButton"
              [placement]="cartPreview_6.placement"
              [triggerType]="cartPreview_6.triggerType"
            >
            </rappider-cart-preview>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 7 -->
            <rappider-icon
              [name]="icon_7.name"
              [color]="icon_7.color"
              [size]="icon_7.size"
              [type]="icon_7.type"
              [theme]="icon_7.theme"
              [animation]="icon_7.animation"
              [style]="icon_7.style"
              [secondColor]="icon_7.secondColor"
            >
            </rappider-icon>
          </div>
        </div>

        <!-- Container: Container 6 -->
        <div class="rappider-container container-6 col-2 py-0">
          <div class="rappider-component">
            <!-- Component: Button 8 -->
            <rappider-button
              [text]="button_8.text"
              [type]="button_8.type"
              [shape]="button_8.shape"
              [size]="button_8.size"
              [colorType]="button_8.colorType"
              [icon]="button_8.icon"
              [iconPlacement]="button_8.iconPlacement"
              [transparent]="button_8.transparent"
              [loading]="button_8.loading"
              [block]="button_8.block"
              [disabled]="button_8.disabled"
              [key]="button_8.key"
              [emitWithoutPopconfirm]="button_8.emitWithoutPopconfirm"
              [popconfirmTitle]="button_8.popconfirmTitle"
              [borderSettings]="button_8.borderSettings"
              [marginSettings]="button_8.marginSettings"
              [paddingSettings]="button_8.paddingSettings"
              [shadowSettings]="button_8.shadowSettings"
              [customColorSettings]="button_8.customColorSettings"
              [customSizeSettings]="button_8.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 9 -->
            <rappider-button
              [text]="button_9.text"
              [type]="button_9.type"
              [shape]="button_9.shape"
              [size]="button_9.size"
              [colorType]="button_9.colorType"
              [icon]="button_9.icon"
              [iconPlacement]="button_9.iconPlacement"
              [transparent]="button_9.transparent"
              [loading]="button_9.loading"
              [block]="button_9.block"
              [disabled]="button_9.disabled"
              [key]="button_9.key"
              [emitWithoutPopconfirm]="button_9.emitWithoutPopconfirm"
              [popconfirmTitle]="button_9.popconfirmTitle"
              [borderSettings]="button_9.borderSettings"
              [marginSettings]="button_9.marginSettings"
              [paddingSettings]="button_9.paddingSettings"
              [shadowSettings]="button_9.shadowSettings"
              [customColorSettings]="button_9.customColorSettings"
              [customSizeSettings]="button_9.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 7 -->
      <div class="rappider-container container-7 col-10 p-0 m-0">
        <div class="rappider-component">
          <!-- Component: Text 10 -->
          <rappider-text
            [textMode]="text_10.textMode"
            [text]="text_10.text"
            [content]="text_10.content"
            [typography]="text_10.typography"
            [colorSettings]="text_10.colorSettings"
          >
          </rappider-text>
        </div>

        <div class="rappider-component">
          <!-- Component: Heading 11 -->
          <rappider-heading
            [content]="heading_11.content"
            [type]="heading_11.type"
          >
          </rappider-heading>
        </div>

        <!-- Container: Container 8 -->
        <div class="rappider-container container-8 col-12 p-0">
          <div class="rappider-component">
            <!-- Component: Input Group 12 -->
            <rappider-input-group
              [prefixIcon]="inputGroup_12.prefixIcon"
              [suffixIcon]="inputGroup_12.suffixIcon"
              [prefixButton]="inputGroup_12.prefixButton"
              [suffixButton]="inputGroup_12.suffixButton"
              [textbox]="inputGroup_12.textbox"
              [prefixText]="inputGroup_12.prefixText"
              [suffixText]="inputGroup_12.suffixText"
            >
            </rappider-input-group>
          </div>

          <div class="rappider-component">
            <!-- Component: Select 13 -->
            <rappider-select
              [grouppedOptions]="select_13.grouppedOptions"
              [placeholder]="select_13.placeholder"
              [invalidConfigText]="select_13.invalidConfigText"
              [disabled]="select_13.disabled"
              [buttons]="select_13.buttons"
              [dropdownMatchSelectWidth]="select_13.dropdownMatchSelectWidth"
              [dropdownClassName]="select_13.dropdownClassName"
              [cssStyle]="select_13.cssStyle"
              [cssClass]="select_13.cssClass"
              [borderSettings]="select_13.borderSettings"
              [sizeSettings]="select_13.sizeSettings"
              [colorSettings]="select_13.colorSettings"
              [boxShadowSettings]="select_13.boxShadowSettings"
              [paddingSettings]="select_13.paddingSettings"
              [marginSettings]="select_13.marginSettings"
              [size]="select_13.size"
              [settings]="select_13.settings"
              [options]="select_13.options"
              [optionMode]="select_13.optionMode"
            >
            </rappider-select>
          </div>
        </div>

        <!-- Container: Container 9 -->
        <div class="rappider-container container-9 col-12 gap-2 p-0 m-0">
          <div class="rappider-component">
            <!-- Component: Button 14 -->
            <rappider-button
              [text]="button_14.text"
              [type]="button_14.type"
              [shape]="button_14.shape"
              [size]="button_14.size"
              [colorType]="button_14.colorType"
              [icon]="button_14.icon"
              [iconPlacement]="button_14.iconPlacement"
              [transparent]="button_14.transparent"
              [loading]="button_14.loading"
              [block]="button_14.block"
              [disabled]="button_14.disabled"
              [key]="button_14.key"
              [emitWithoutPopconfirm]="button_14.emitWithoutPopconfirm"
              [popconfirmTitle]="button_14.popconfirmTitle"
              [borderSettings]="button_14.borderSettings"
              [marginSettings]="button_14.marginSettings"
              [paddingSettings]="button_14.paddingSettings"
              [shadowSettings]="button_14.shadowSettings"
              [customColorSettings]="button_14.customColorSettings"
              [customSizeSettings]="button_14.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 15 -->
            <rappider-button
              [text]="button_15.text"
              [type]="button_15.type"
              [shape]="button_15.shape"
              [size]="button_15.size"
              [colorType]="button_15.colorType"
              [icon]="button_15.icon"
              [iconPlacement]="button_15.iconPlacement"
              [transparent]="button_15.transparent"
              [loading]="button_15.loading"
              [block]="button_15.block"
              [disabled]="button_15.disabled"
              [key]="button_15.key"
              [emitWithoutPopconfirm]="button_15.emitWithoutPopconfirm"
              [popconfirmTitle]="button_15.popconfirmTitle"
              [borderSettings]="button_15.borderSettings"
              [marginSettings]="button_15.marginSettings"
              [paddingSettings]="button_15.paddingSettings"
              [shadowSettings]="button_15.shadowSettings"
              [customColorSettings]="button_15.customColorSettings"
              [customSizeSettings]="button_15.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 16 -->
            <rappider-button
              [text]="button_16.text"
              [type]="button_16.type"
              [shape]="button_16.shape"
              [size]="button_16.size"
              [colorType]="button_16.colorType"
              [icon]="button_16.icon"
              [iconPlacement]="button_16.iconPlacement"
              [transparent]="button_16.transparent"
              [loading]="button_16.loading"
              [block]="button_16.block"
              [disabled]="button_16.disabled"
              [key]="button_16.key"
              [emitWithoutPopconfirm]="button_16.emitWithoutPopconfirm"
              [popconfirmTitle]="button_16.popconfirmTitle"
              [borderSettings]="button_16.borderSettings"
              [marginSettings]="button_16.marginSettings"
              [paddingSettings]="button_16.paddingSettings"
              [shadowSettings]="button_16.shadowSettings"
              [customColorSettings]="button_16.customColorSettings"
              [customSizeSettings]="button_16.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 17 -->
            <rappider-button
              [text]="button_17.text"
              [type]="button_17.type"
              [shape]="button_17.shape"
              [size]="button_17.size"
              [colorType]="button_17.colorType"
              [icon]="button_17.icon"
              [iconPlacement]="button_17.iconPlacement"
              [transparent]="button_17.transparent"
              [loading]="button_17.loading"
              [block]="button_17.block"
              [disabled]="button_17.disabled"
              [key]="button_17.key"
              [emitWithoutPopconfirm]="button_17.emitWithoutPopconfirm"
              [popconfirmTitle]="button_17.popconfirmTitle"
              [borderSettings]="button_17.borderSettings"
              [marginSettings]="button_17.marginSettings"
              [paddingSettings]="button_17.paddingSettings"
              [shadowSettings]="button_17.shadowSettings"
              [customColorSettings]="button_17.customColorSettings"
              [customSizeSettings]="button_17.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 18 -->
            <rappider-button
              [text]="button_18.text"
              [type]="button_18.type"
              [shape]="button_18.shape"
              [size]="button_18.size"
              [colorType]="button_18.colorType"
              [icon]="button_18.icon"
              [iconPlacement]="button_18.iconPlacement"
              [transparent]="button_18.transparent"
              [loading]="button_18.loading"
              [block]="button_18.block"
              [disabled]="button_18.disabled"
              [key]="button_18.key"
              [emitWithoutPopconfirm]="button_18.emitWithoutPopconfirm"
              [popconfirmTitle]="button_18.popconfirmTitle"
              [borderSettings]="button_18.borderSettings"
              [marginSettings]="button_18.marginSettings"
              [paddingSettings]="button_18.paddingSettings"
              [shadowSettings]="button_18.shadowSettings"
              [customColorSettings]="button_18.customColorSettings"
              [customSizeSettings]="button_18.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 19 -->
            <rappider-button
              [text]="button_19.text"
              [type]="button_19.type"
              [shape]="button_19.shape"
              [size]="button_19.size"
              [colorType]="button_19.colorType"
              [icon]="button_19.icon"
              [iconPlacement]="button_19.iconPlacement"
              [transparent]="button_19.transparent"
              [loading]="button_19.loading"
              [block]="button_19.block"
              [disabled]="button_19.disabled"
              [key]="button_19.key"
              [emitWithoutPopconfirm]="button_19.emitWithoutPopconfirm"
              [popconfirmTitle]="button_19.popconfirmTitle"
              [borderSettings]="button_19.borderSettings"
              [marginSettings]="button_19.marginSettings"
              [paddingSettings]="button_19.paddingSettings"
              [shadowSettings]="button_19.shadowSettings"
              [customColorSettings]="button_19.customColorSettings"
              [customSizeSettings]="button_19.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 10 -->
      <div
        class="rappider-container container-10 col-12 container-spacing-settings mobile-navbar-bg mobile-navbar-settings"
      >
        <!-- Container: Container 11 -->
        <div
          class="rappider-container container-11 col-12 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Image 20 -->
            <rappider-image
              [source]="image_20.source"
              [alternateText]="image_20.alternateText"
              [placeholder]="image_20.placeholder"
              [disablePreview]="image_20.disablePreview"
              [borderSettings]="image_20.borderSettings"
              [shadowSettings]="image_20.shadowSettings"
              [paddingSettings]="image_20.paddingSettings"
              [marginSettings]="image_20.marginSettings"
              [customSizeSettings]="image_20.customSizeSettings"
            >
            </rappider-image>
          </div>

          <!-- Container: Container 12 -->
          <div
            class="rappider-container container-12 col-1 container-spacing-settings"
          >
            <div class="rappider-component">
              <!-- Component: Cart Preview  21 -->
              <rappider-cart-preview
                [cartItem]="cartPreview_21.cartItem"
                [footer]="cartPreview_21.footer"
                [footerContent]="cartPreview_21.footerContent"
                [buttons]="cartPreview_21.buttons"
                [dropdownButton]="cartPreview_21.dropdownButton"
                [placement]="cartPreview_21.placement"
                [triggerType]="cartPreview_21.triggerType"
              >
              </rappider-cart-preview>
            </div>

            <div class="rappider-component">
              <!-- Component: Icon 22 -->
              <rappider-icon
                [name]="icon_22.name"
                [color]="icon_22.color"
                [size]="icon_22.size"
                [type]="icon_22.type"
                [theme]="icon_22.theme"
                [animation]="icon_22.animation"
                [style]="icon_22.style"
                [secondColor]="icon_22.secondColor"
              >
              </rappider-icon>
            </div>
          </div>
        </div>

        <!-- Container: Container 13 -->
        <div class="rappider-container container-13 col-12 p-0 m-0">
          <div class="rappider-component">
            <!-- Component: Input Group 23 -->
            <rappider-input-group
              [prefixIcon]="inputGroup_23.prefixIcon"
              [suffixIcon]="inputGroup_23.suffixIcon"
              [prefixButton]="inputGroup_23.prefixButton"
              [suffixButton]="inputGroup_23.suffixButton"
              [textbox]="inputGroup_23.textbox"
              [prefixText]="inputGroup_23.prefixText"
              [suffixText]="inputGroup_23.suffixText"
            >
            </rappider-input-group>
          </div>
        </div>
      </div>

      <!-- Container: Container 14 -->
      <div class="rappider-container container-14 col-12 p-0 m-0">
        <div class="rappider-component">
          <!-- Component: Text 24 -->
          <rappider-text
            [textMode]="text_24.textMode"
            [text]="text_24.text"
            [content]="text_24.content"
            [typography]="text_24.typography"
            [colorSettings]="text_24.colorSettings"
          >
          </rappider-text>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 25 -->
          <rappider-button
            [text]="button_25.text"
            [type]="button_25.type"
            [shape]="button_25.shape"
            [size]="button_25.size"
            [colorType]="button_25.colorType"
            [icon]="button_25.icon"
            [iconPlacement]="button_25.iconPlacement"
            [transparent]="button_25.transparent"
            [loading]="button_25.loading"
            [block]="button_25.block"
            [disabled]="button_25.disabled"
            [key]="button_25.key"
            [emitWithoutPopconfirm]="button_25.emitWithoutPopconfirm"
            [popconfirmTitle]="button_25.popconfirmTitle"
            [borderSettings]="button_25.borderSettings"
            [marginSettings]="button_25.marginSettings"
            [paddingSettings]="button_25.paddingSettings"
            [shadowSettings]="button_25.shadowSettings"
            [customColorSettings]="button_25.customColorSettings"
            [customSizeSettings]="button_25.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>
    </div>

    <div class="rappider-component banner-image-position z-1 object-fit-cover">
      <!-- Component: Image 26 -->
      <rappider-image
        [source]="image_26.source"
        [alternateText]="image_26.alternateText"
        [placeholder]="image_26.placeholder"
        [disablePreview]="image_26.disablePreview"
        [borderSettings]="image_26.borderSettings"
        [shadowSettings]="image_26.shadowSettings"
        [paddingSettings]="image_26.paddingSettings"
        [marginSettings]="image_26.marginSettings"
        [customSizeSettings]="image_26.customSizeSettings"
      >
      </rappider-image>
    </div>
  </div>

  <div>
    <router-outlet></router-outlet>
  </div>

  <!-- Container: Container 15 -->
  <div class="rappider-container container-15 col-12">
    <!-- Container: Container 16 -->
    <div class="rappider-container container-16 col-12">
      <!-- Container: Container 17 -->
      <div class="rappider-container container-17 col-7">
        <div class="rappider-component">
          <!-- Component: Heading 27 -->
          <rappider-heading
            [content]="heading_27.content"
            [type]="heading_27.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Text 28 -->
          <rappider-text
            [textMode]="text_28.textMode"
            [text]="text_28.text"
            [content]="text_28.content"
            [typography]="text_28.typography"
            [colorSettings]="text_28.colorSettings"
          >
          </rappider-text>
        </div>
      </div>

      <!-- Container: Container 18 -->
      <div class="rappider-container container-18 col-5">
        <div class="rappider-component">
          <!-- Component: Textbox 29 -->
          <rappider-textbox
            [placeholder]="textbox_29.placeholder"
            [type]="textbox_29.type"
            [mask]="textbox_29.mask"
            [maskGuide]="textbox_29.maskGuide"
            [cssStyle]="textbox_29.cssStyle"
            [cssClass]="textbox_29.cssClass"
            [disabled]="textbox_29.disabled"
            [mentionSupported]="textbox_29.mentionSupported"
            [mentionPrefix]="textbox_29.mentionPrefix"
            [mentionValues]="textbox_29.mentionValues"
            [borderSettings]="textbox_29.borderSettings"
            [sizeSettings]="textbox_29.sizeSettings"
            [colorSettings]="textbox_29.colorSettings"
            [boxShadowSettings]="textbox_29.boxShadowSettings"
            [paddingSettings]="textbox_29.paddingSettings"
            [marginSettings]="textbox_29.marginSettings"
            [size]="textbox_29.size"
          >
          </rappider-textbox>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 30 -->
          <rappider-button
            [text]="button_30.text"
            [type]="button_30.type"
            [shape]="button_30.shape"
            [size]="button_30.size"
            [colorType]="button_30.colorType"
            [icon]="button_30.icon"
            [iconPlacement]="button_30.iconPlacement"
            [transparent]="button_30.transparent"
            [loading]="button_30.loading"
            [block]="button_30.block"
            [disabled]="button_30.disabled"
            [key]="button_30.key"
            [emitWithoutPopconfirm]="button_30.emitWithoutPopconfirm"
            [popconfirmTitle]="button_30.popconfirmTitle"
            [borderSettings]="button_30.borderSettings"
            [marginSettings]="button_30.marginSettings"
            [paddingSettings]="button_30.paddingSettings"
            [shadowSettings]="button_30.shadowSettings"
            [customColorSettings]="button_30.customColorSettings"
            [customSizeSettings]="button_30.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>
    </div>

    <!-- Container: Container 19 -->
    <div class="rappider-container container-19 col-12">
      <div class="rappider-component">
        <!-- Component: Divider 31 -->
        <rappider-divider
          [style]="divider_31.style"
          [type]="divider_31.type"
          [text]="divider_31.text"
          [textPlacement]="divider_31.textPlacement"
          [dividerWidth]="divider_31.dividerWidth"
          [dividerColor]="divider_31.dividerColor"
        >
        </rappider-divider>
      </div>
    </div>

    <!-- Container: Container 20 -->
    <div class="rappider-container container-20 col-12 flex-wrap-responsive">
      <!-- Container: Container 21 -->
      <div class="rappider-container container-21 col-5">
        <!-- Container: Container 22 -->
        <div class="rappider-container container-22 col-12">
          <div class="rappider-component">
            <!-- Component: Heading 32 -->
            <rappider-heading
              [content]="heading_32.content"
              [type]="heading_32.type"
            >
            </rappider-heading>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 33 -->
            <rappider-text
              [textMode]="text_33.textMode"
              [text]="text_33.text"
              [content]="text_33.content"
              [typography]="text_33.typography"
              [colorSettings]="text_33.colorSettings"
            >
            </rappider-text>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 34 -->
            <rappider-text
              [textMode]="text_34.textMode"
              [text]="text_34.text"
              [content]="text_34.content"
              [typography]="text_34.typography"
              [colorSettings]="text_34.colorSettings"
            >
            </rappider-text>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 35 -->
            <rappider-text
              [textMode]="text_35.textMode"
              [text]="text_35.text"
              [content]="text_35.content"
              [typography]="text_35.typography"
              [colorSettings]="text_35.colorSettings"
            >
            </rappider-text>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 36 -->
            <rappider-text
              [textMode]="text_36.textMode"
              [text]="text_36.text"
              [content]="text_36.content"
              [typography]="text_36.typography"
              [colorSettings]="text_36.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 23 -->
        <div class="rappider-container container-23 col-12">
          <div class="rappider-component">
            <!-- Component: Icon 37 -->
            <rappider-icon
              [name]="icon_37.name"
              [color]="icon_37.color"
              [size]="icon_37.size"
              [type]="icon_37.type"
              [theme]="icon_37.theme"
              [animation]="icon_37.animation"
              [style]="icon_37.style"
              [secondColor]="icon_37.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 38 -->
            <rappider-icon
              [name]="icon_38.name"
              [color]="icon_38.color"
              [size]="icon_38.size"
              [type]="icon_38.type"
              [theme]="icon_38.theme"
              [animation]="icon_38.animation"
              [style]="icon_38.style"
              [secondColor]="icon_38.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 39 -->
            <rappider-icon
              [name]="icon_39.name"
              [color]="icon_39.color"
              [size]="icon_39.size"
              [type]="icon_39.type"
              [theme]="icon_39.theme"
              [animation]="icon_39.animation"
              [style]="icon_39.style"
              [secondColor]="icon_39.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 40 -->
            <rappider-icon
              [name]="icon_40.name"
              [color]="icon_40.color"
              [size]="icon_40.size"
              [type]="icon_40.type"
              [theme]="icon_40.theme"
              [animation]="icon_40.animation"
              [style]="icon_40.style"
              [secondColor]="icon_40.secondColor"
            >
            </rappider-icon>
          </div>
        </div>
      </div>

      <!-- Container: Container 24 -->
      <div class="rappider-container container-24 col-2">
        <div class="rappider-component">
          <!-- Component: Heading 41 -->
          <rappider-heading
            [content]="heading_41.content"
            [type]="heading_41.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 42 -->
          <rappider-button
            [text]="button_42.text"
            [type]="button_42.type"
            [shape]="button_42.shape"
            [size]="button_42.size"
            [colorType]="button_42.colorType"
            [icon]="button_42.icon"
            [iconPlacement]="button_42.iconPlacement"
            [transparent]="button_42.transparent"
            [loading]="button_42.loading"
            [block]="button_42.block"
            [disabled]="button_42.disabled"
            [key]="button_42.key"
            [emitWithoutPopconfirm]="button_42.emitWithoutPopconfirm"
            [popconfirmTitle]="button_42.popconfirmTitle"
            [borderSettings]="button_42.borderSettings"
            [marginSettings]="button_42.marginSettings"
            [paddingSettings]="button_42.paddingSettings"
            [shadowSettings]="button_42.shadowSettings"
            [customColorSettings]="button_42.customColorSettings"
            [customSizeSettings]="button_42.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 43 -->
          <rappider-button
            [text]="button_43.text"
            [type]="button_43.type"
            [shape]="button_43.shape"
            [size]="button_43.size"
            [colorType]="button_43.colorType"
            [icon]="button_43.icon"
            [iconPlacement]="button_43.iconPlacement"
            [transparent]="button_43.transparent"
            [loading]="button_43.loading"
            [block]="button_43.block"
            [disabled]="button_43.disabled"
            [key]="button_43.key"
            [emitWithoutPopconfirm]="button_43.emitWithoutPopconfirm"
            [popconfirmTitle]="button_43.popconfirmTitle"
            [borderSettings]="button_43.borderSettings"
            [marginSettings]="button_43.marginSettings"
            [paddingSettings]="button_43.paddingSettings"
            [shadowSettings]="button_43.shadowSettings"
            [customColorSettings]="button_43.customColorSettings"
            [customSizeSettings]="button_43.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 44 -->
          <rappider-button
            [text]="button_44.text"
            [type]="button_44.type"
            [shape]="button_44.shape"
            [size]="button_44.size"
            [colorType]="button_44.colorType"
            [icon]="button_44.icon"
            [iconPlacement]="button_44.iconPlacement"
            [transparent]="button_44.transparent"
            [loading]="button_44.loading"
            [block]="button_44.block"
            [disabled]="button_44.disabled"
            [key]="button_44.key"
            [emitWithoutPopconfirm]="button_44.emitWithoutPopconfirm"
            [popconfirmTitle]="button_44.popconfirmTitle"
            [borderSettings]="button_44.borderSettings"
            [marginSettings]="button_44.marginSettings"
            [paddingSettings]="button_44.paddingSettings"
            [shadowSettings]="button_44.shadowSettings"
            [customColorSettings]="button_44.customColorSettings"
            [customSizeSettings]="button_44.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 45 -->
          <rappider-button
            [text]="button_45.text"
            [type]="button_45.type"
            [shape]="button_45.shape"
            [size]="button_45.size"
            [colorType]="button_45.colorType"
            [icon]="button_45.icon"
            [iconPlacement]="button_45.iconPlacement"
            [transparent]="button_45.transparent"
            [loading]="button_45.loading"
            [block]="button_45.block"
            [disabled]="button_45.disabled"
            [key]="button_45.key"
            [emitWithoutPopconfirm]="button_45.emitWithoutPopconfirm"
            [popconfirmTitle]="button_45.popconfirmTitle"
            [borderSettings]="button_45.borderSettings"
            [marginSettings]="button_45.marginSettings"
            [paddingSettings]="button_45.paddingSettings"
            [shadowSettings]="button_45.shadowSettings"
            [customColorSettings]="button_45.customColorSettings"
            [customSizeSettings]="button_45.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 46 -->
          <rappider-button
            [text]="button_46.text"
            [type]="button_46.type"
            [shape]="button_46.shape"
            [size]="button_46.size"
            [colorType]="button_46.colorType"
            [icon]="button_46.icon"
            [iconPlacement]="button_46.iconPlacement"
            [transparent]="button_46.transparent"
            [loading]="button_46.loading"
            [block]="button_46.block"
            [disabled]="button_46.disabled"
            [key]="button_46.key"
            [emitWithoutPopconfirm]="button_46.emitWithoutPopconfirm"
            [popconfirmTitle]="button_46.popconfirmTitle"
            [borderSettings]="button_46.borderSettings"
            [marginSettings]="button_46.marginSettings"
            [paddingSettings]="button_46.paddingSettings"
            [shadowSettings]="button_46.shadowSettings"
            [customColorSettings]="button_46.customColorSettings"
            [customSizeSettings]="button_46.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 25 -->
      <div class="rappider-container container-25 col-2">
        <div class="rappider-component">
          <!-- Component: Heading 47 -->
          <rappider-heading
            [content]="heading_47.content"
            [type]="heading_47.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 48 -->
          <rappider-button
            [text]="button_48.text"
            [type]="button_48.type"
            [shape]="button_48.shape"
            [size]="button_48.size"
            [colorType]="button_48.colorType"
            [icon]="button_48.icon"
            [iconPlacement]="button_48.iconPlacement"
            [transparent]="button_48.transparent"
            [loading]="button_48.loading"
            [block]="button_48.block"
            [disabled]="button_48.disabled"
            [key]="button_48.key"
            [emitWithoutPopconfirm]="button_48.emitWithoutPopconfirm"
            [popconfirmTitle]="button_48.popconfirmTitle"
            [borderSettings]="button_48.borderSettings"
            [marginSettings]="button_48.marginSettings"
            [paddingSettings]="button_48.paddingSettings"
            [shadowSettings]="button_48.shadowSettings"
            [customColorSettings]="button_48.customColorSettings"
            [customSizeSettings]="button_48.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 49 -->
          <rappider-button
            [text]="button_49.text"
            [type]="button_49.type"
            [shape]="button_49.shape"
            [size]="button_49.size"
            [colorType]="button_49.colorType"
            [icon]="button_49.icon"
            [iconPlacement]="button_49.iconPlacement"
            [transparent]="button_49.transparent"
            [loading]="button_49.loading"
            [block]="button_49.block"
            [disabled]="button_49.disabled"
            [key]="button_49.key"
            [emitWithoutPopconfirm]="button_49.emitWithoutPopconfirm"
            [popconfirmTitle]="button_49.popconfirmTitle"
            [borderSettings]="button_49.borderSettings"
            [marginSettings]="button_49.marginSettings"
            [paddingSettings]="button_49.paddingSettings"
            [shadowSettings]="button_49.shadowSettings"
            [customColorSettings]="button_49.customColorSettings"
            [customSizeSettings]="button_49.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 50 -->
          <rappider-button
            [text]="button_50.text"
            [type]="button_50.type"
            [shape]="button_50.shape"
            [size]="button_50.size"
            [colorType]="button_50.colorType"
            [icon]="button_50.icon"
            [iconPlacement]="button_50.iconPlacement"
            [transparent]="button_50.transparent"
            [loading]="button_50.loading"
            [block]="button_50.block"
            [disabled]="button_50.disabled"
            [key]="button_50.key"
            [emitWithoutPopconfirm]="button_50.emitWithoutPopconfirm"
            [popconfirmTitle]="button_50.popconfirmTitle"
            [borderSettings]="button_50.borderSettings"
            [marginSettings]="button_50.marginSettings"
            [paddingSettings]="button_50.paddingSettings"
            [shadowSettings]="button_50.shadowSettings"
            [customColorSettings]="button_50.customColorSettings"
            [customSizeSettings]="button_50.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 51 -->
          <rappider-button
            [text]="button_51.text"
            [type]="button_51.type"
            [shape]="button_51.shape"
            [size]="button_51.size"
            [colorType]="button_51.colorType"
            [icon]="button_51.icon"
            [iconPlacement]="button_51.iconPlacement"
            [transparent]="button_51.transparent"
            [loading]="button_51.loading"
            [block]="button_51.block"
            [disabled]="button_51.disabled"
            [key]="button_51.key"
            [emitWithoutPopconfirm]="button_51.emitWithoutPopconfirm"
            [popconfirmTitle]="button_51.popconfirmTitle"
            [borderSettings]="button_51.borderSettings"
            [marginSettings]="button_51.marginSettings"
            [paddingSettings]="button_51.paddingSettings"
            [shadowSettings]="button_51.shadowSettings"
            [customColorSettings]="button_51.customColorSettings"
            [customSizeSettings]="button_51.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 26 -->
      <div class="rappider-container container-26 col-2">
        <div class="rappider-component">
          <!-- Component: Heading 52 -->
          <rappider-heading
            [content]="heading_52.content"
            [type]="heading_52.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 53 -->
          <rappider-button
            [text]="button_53.text"
            [type]="button_53.type"
            [shape]="button_53.shape"
            [size]="button_53.size"
            [colorType]="button_53.colorType"
            [icon]="button_53.icon"
            [iconPlacement]="button_53.iconPlacement"
            [transparent]="button_53.transparent"
            [loading]="button_53.loading"
            [block]="button_53.block"
            [disabled]="button_53.disabled"
            [key]="button_53.key"
            [emitWithoutPopconfirm]="button_53.emitWithoutPopconfirm"
            [popconfirmTitle]="button_53.popconfirmTitle"
            [borderSettings]="button_53.borderSettings"
            [marginSettings]="button_53.marginSettings"
            [paddingSettings]="button_53.paddingSettings"
            [shadowSettings]="button_53.shadowSettings"
            [customColorSettings]="button_53.customColorSettings"
            [customSizeSettings]="button_53.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 54 -->
          <rappider-button
            [text]="button_54.text"
            [type]="button_54.type"
            [shape]="button_54.shape"
            [size]="button_54.size"
            [colorType]="button_54.colorType"
            [icon]="button_54.icon"
            [iconPlacement]="button_54.iconPlacement"
            [transparent]="button_54.transparent"
            [loading]="button_54.loading"
            [block]="button_54.block"
            [disabled]="button_54.disabled"
            [key]="button_54.key"
            [emitWithoutPopconfirm]="button_54.emitWithoutPopconfirm"
            [popconfirmTitle]="button_54.popconfirmTitle"
            [borderSettings]="button_54.borderSettings"
            [marginSettings]="button_54.marginSettings"
            [paddingSettings]="button_54.paddingSettings"
            [shadowSettings]="button_54.shadowSettings"
            [customColorSettings]="button_54.customColorSettings"
            [customSizeSettings]="button_54.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 55 -->
          <rappider-button
            [text]="button_55.text"
            [type]="button_55.type"
            [shape]="button_55.shape"
            [size]="button_55.size"
            [colorType]="button_55.colorType"
            [icon]="button_55.icon"
            [iconPlacement]="button_55.iconPlacement"
            [transparent]="button_55.transparent"
            [loading]="button_55.loading"
            [block]="button_55.block"
            [disabled]="button_55.disabled"
            [key]="button_55.key"
            [emitWithoutPopconfirm]="button_55.emitWithoutPopconfirm"
            [popconfirmTitle]="button_55.popconfirmTitle"
            [borderSettings]="button_55.borderSettings"
            [marginSettings]="button_55.marginSettings"
            [paddingSettings]="button_55.paddingSettings"
            [shadowSettings]="button_55.shadowSettings"
            [customColorSettings]="button_55.customColorSettings"
            [customSizeSettings]="button_55.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 56 -->
          <rappider-button
            [text]="button_56.text"
            [type]="button_56.type"
            [shape]="button_56.shape"
            [size]="button_56.size"
            [colorType]="button_56.colorType"
            [icon]="button_56.icon"
            [iconPlacement]="button_56.iconPlacement"
            [transparent]="button_56.transparent"
            [loading]="button_56.loading"
            [block]="button_56.block"
            [disabled]="button_56.disabled"
            [key]="button_56.key"
            [emitWithoutPopconfirm]="button_56.emitWithoutPopconfirm"
            [popconfirmTitle]="button_56.popconfirmTitle"
            [borderSettings]="button_56.borderSettings"
            [marginSettings]="button_56.marginSettings"
            [paddingSettings]="button_56.paddingSettings"
            [shadowSettings]="button_56.shadowSettings"
            [customColorSettings]="button_56.customColorSettings"
            [customSizeSettings]="button_56.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>
    </div>

    <!-- Container: Container 27 -->
    <div class="rappider-container container-27 col-12">
      <div class="rappider-component">
        <!-- Component: Divider 57 -->
        <rappider-divider
          [style]="divider_57.style"
          [type]="divider_57.type"
          [text]="divider_57.text"
          [textPlacement]="divider_57.textPlacement"
          [dividerWidth]="divider_57.dividerWidth"
          [dividerColor]="divider_57.dividerColor"
        >
        </rappider-divider>
      </div>
    </div>

    <!-- Container: Container 28 -->
    <div class="rappider-container container-28 col-12">
      <!-- Container: Container 29 -->
      <div class="rappider-container container-29 col-6">
        <div class="rappider-component">
          <!-- Component: Text 58 -->
          <rappider-text
            [textMode]="text_58.textMode"
            [text]="text_58.text"
            [content]="text_58.content"
            [typography]="text_58.typography"
            [colorSettings]="text_58.colorSettings"
          >
          </rappider-text>
        </div>
      </div>

      <!-- Container: Container 30 -->
      <div class="rappider-container container-30 col-6">
        <div class="rappider-component">
          <!-- Component: Text 59 -->
          <rappider-text
            [textMode]="text_59.textMode"
            [text]="text_59.text"
            [content]="text_59.content"
            [typography]="text_59.typography"
            [colorSettings]="text_59.colorSettings"
          >
          </rappider-text>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 60 -->
          <rappider-image
            [source]="image_60.source"
            [alternateText]="image_60.alternateText"
            [placeholder]="image_60.placeholder"
            [disablePreview]="image_60.disablePreview"
            [borderSettings]="image_60.borderSettings"
            [shadowSettings]="image_60.shadowSettings"
            [paddingSettings]="image_60.paddingSettings"
            [marginSettings]="image_60.marginSettings"
            [customSizeSettings]="image_60.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 61 -->
          <rappider-image
            [source]="image_61.source"
            [alternateText]="image_61.alternateText"
            [placeholder]="image_61.placeholder"
            [disablePreview]="image_61.disablePreview"
            [borderSettings]="image_61.borderSettings"
            [shadowSettings]="image_61.shadowSettings"
            [paddingSettings]="image_61.paddingSettings"
            [marginSettings]="image_61.marginSettings"
            [customSizeSettings]="image_61.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 62 -->
          <rappider-image
            [source]="image_62.source"
            [alternateText]="image_62.alternateText"
            [placeholder]="image_62.placeholder"
            [disablePreview]="image_62.disablePreview"
            [borderSettings]="image_62.borderSettings"
            [shadowSettings]="image_62.shadowSettings"
            [paddingSettings]="image_62.paddingSettings"
            [marginSettings]="image_62.marginSettings"
            [customSizeSettings]="image_62.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 63 -->
          <rappider-image
            [source]="image_63.source"
            [alternateText]="image_63.alternateText"
            [placeholder]="image_63.placeholder"
            [disablePreview]="image_63.disablePreview"
            [borderSettings]="image_63.borderSettings"
            [shadowSettings]="image_63.shadowSettings"
            [paddingSettings]="image_63.paddingSettings"
            [marginSettings]="image_63.marginSettings"
            [customSizeSettings]="image_63.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 64 -->
          <rappider-image
            [source]="image_64.source"
            [alternateText]="image_64.alternateText"
            [placeholder]="image_64.placeholder"
            [disablePreview]="image_64.disablePreview"
            [borderSettings]="image_64.borderSettings"
            [shadowSettings]="image_64.shadowSettings"
            [paddingSettings]="image_64.paddingSettings"
            [marginSettings]="image_64.marginSettings"
            [customSizeSettings]="image_64.customSizeSettings"
          >
          </rappider-image>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__footer__end -->

<!-- #endregion customCode: page-component-html__footer__end -->
